import { STATUS } from '@features/General'
import { createSlice } from '@reduxjs/toolkit'

export interface IFinalizeImportState {
    status: string
    data: any
    errors: any
}

const initialState: IFinalizeImportState = {
    status: STATUS.IDLE,
    data: null,
    errors: null
}

const finalizeImportSlice = createSlice({
    name: 'hub/data-import/finalize',
    initialState,
    reducers: {
        onRequest(state) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const finalizeImportActions = finalizeImportSlice.actions
export default finalizeImportSlice.reducer
